import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField  from "../../../../../../../../ui/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
    block: {
      margin: "35px 0 15px 0"
    },
    blockrow: {
      marginTop: 16
    },
    blockfieldValue: {
      marginTop: 8
    },
    label: {
      fontSize: 12
    },
    svgIcon:{
      display: "inline-block",
      marginBottom: "-8px",
      marginRight: "8px"
    },
    typofield: {
      width: 140,
      minWidth: 140,
      paddingRight: 16
    },
    typovalue: {
      fontSize: 12,
    }
  });



const SkillViewStaff = (props) => {
  const classes = useStyles();
  const {teacherLevel, teacherStage, teacherProf, teacherExtra} = props;

  return (
      <div className={classes.root}>
      <Typography className={classes.heading}>Требования к квалификации педагогического состава</Typography>
      <Grid container spacing={2} className={classes.mainGrid}>
        <Grid item xs={12} md={6}>
          <TextField
            value={teacherLevel}
            label="Уровень образования"
            readOnly
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            value={teacherProf}
            label="Квалификация"
            readOnly
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            value={teacherStage}
            label="Опыт работы"
            readOnly
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={teacherExtra}
            label="Дополнительно"
            readOnly
            multiline
          />
        </Grid>
      </Grid>
    </div>
  );
};



export default SkillViewStaff;
